<div class="our-programs" id="our-programs">
  <div class="container">
    <span class="badge-pill">{{ 'our_programs.badge' | translate }}</span>
    <h2 class="section-title mb-3">{{ 'our_programs.heading' | translate }}</h2>
    <p class="section-desc">{{ 'our_programs.subheading' | translate }}</p>

    <div class="row g-4 program-cards">
      @for (program of programs; track program) {
      <div class="col-12 col-md-6 col-lg-4">
        <div class="program-card">
          <!-- TODO: replace with actual program-icon.svg -->
          <img class="program-icon" [src]="program.icon" alt="" loading="lazy" />
          <p class="program-eyebrow">{{ program.eyebrowKey | translate }}</p>
          <h3 class="program-title">{{ program.titleKey | translate }}</h3>
          <p class="program-desc">{{ program.descKey | translate }}</p>
          <span class="program-arrow" aria-hidden="true">→</span>
        </div>
      </div>
      }
    </div>
  </div>
</div>